/* Version: 3.5.155 */
'use client';
var DEFAULT_INPUT_WIDTH = 295;

export { DEFAULT_INPUT_WIDTH };
